// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"766b1b73","77":"12061cec","239":"7d5e8511","488":"95106d3f","863":"5b21a1c7"}[chunkId] + ".chunk.js";
};